"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groceryItemsQuery = void 0;
const client_1 = require("@apollo/client");
const groceryItem_1 = require("../fragments/groceryItem");
exports.groceryItemsQuery = client_1.gql `
  query GroceryItems {
    groceryItems {
      items {
        ...GroceryListItem
      }
      recipes {
        ...GroceryRecipeInfo
      }
    }
  }
  ${groceryItem_1.groceryRecipeInfoFragment}
  ${groceryItem_1.groceryListItemFragment}
`;
//# sourceMappingURL=groceryItems.js.map